import { IAppState } from '../state/app.state';
import { createSelector } from '@ngrx/store';
import { IScoState } from '../state/sco.state';

const scoState = (state: IAppState) => state.sco;

export const selectSco = createSelector(
  scoState,
  (state: IScoState) => state.sco
);
